import React, { useEffect, useState } from 'react'
import { papyrusUserLookUpUrl } from '@services/fifthaveClient'
import NameEditor from '@components/ProductName'
import bulldozer from "../../API/bulldozer"
import moment from 'moment-timezone'
import { Table, message, Modal as AntModal, Badge, Tooltip, Tag, Space, Typography } from 'antd'
import { ContainerTwoTone, QuestionOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom';
import { getMarkUpPolicies } from '@services/productService'
import { Decimal } from 'decimal.js' 

const { Paragraph } = Typography
const tipStyle = { backgroundColor: '#faad14', padding: 1, borderRadius: '50%', color: '#fff', marginTop: -2 }

function ProductDetailHeader(props) {
  const [markUpId, setMarkUpId] = useState('')
  const [ratio, setRatio] = useState<Record<string, number>>({})
  const { product, hasRule, productPriceSection, refreshProductInfo, renameProduct, modifyNameHistoryList } = props || {} //product
  const [showNameHistoryModal, setShowNameHistoryModal] = useState(false)
  let productPined: boolean = false
  if (product.attributes) {
      productPined = product.attributes.attributes?.pinned?.choices?.[0] === '_all'
  }
  const inventery = productPined ? `${product.inventoryStatus} (Pined)` : `${product.inventoryStatus}`

  const getChoices = () => {
      let attributes = product.attributes
      if (attributes && attributes.attributes && attributes.attributes.status_description
          && attributes.attributes.status_description.choices) {
          return attributes.attributes.status_description.choices[0]
      }
      return false
  }

  const _renameProduct = (newName, callBack) => {
      renameProduct(product.id, newName, callBack)
  }

  const recrawlerProduct = (product_id) => {
      bulldozer.post(`api/scripts`, {
          "taskType": "runspider",
          "runArgs": `-p ${product_id} -o -k -m`
      }).then((response) => {
          message.success('成功')
      }).catch(error => {
          alert(error);
      })
  }
  
  const salesHistoryLink = () => {
      if (!product) return null
      const end = moment().utc().format('YYYY-MM-DD')
      const start = moment().subtract(60, 'days').utc().format('YYYY-MM-DD')
      return `https://plutus.bybieyang.com/dashboard/509?start_date=${start}&end_date=${end}&productid=${product.id}`
  }

  const getPinToTime = () => {
      if (product.pinInfos && product.pinInfos.length > 0) {
          let pinTime = product.pinInfos.find(item => item.name.includes('_all'))
          if (pinTime && pinTime.expiredAt) {
              return `Pined To ${moment(pinTime.expiredAt).format('YYYY/MM/DD HH:mm')}`
          }
      }
      return ''
  }

  useEffect(() => {
    if (productPriceSection.mark_up_id){
        getMarkUpPolicies(productPriceSection.mark_up_id).then(({data}) => {
            setMarkUpId(data.refId)
            setRatio({
              percentage: data.percentage,
              processingFeeRateDeduct: data.processingFeeRateDeduct,
            })
        })
    }
  }, [productPriceSection.mark_up_id])


  const getCommissionFee = () => {
     const { percentage, processingFeeRateDeduct } = ratio
     if (productPriceSection.type === 'commission') {
       return (
         productPriceSection.unit +
         new Decimal(productPriceSection.price || 0)
           .mul(new Decimal(processingFeeRateDeduct || 0).div(100))
           .toFixed(2)
       )
     } else {
      return productPriceSection.unit + new Decimal(productPriceSection?.diff || 0)
         .mul(new Decimal(processingFeeRateDeduct || 0).div(percentage || 0))
         .toFixed(2)
     }
  }

  return (
    <div className="row">
      <dt className="col-sm-4">Product Name: </dt>
      <dd className={hasRule ? 'col-md-7' : 'col-md-8'}>
        <NameEditor product={product} saveAndRename={_renameProduct} />
      </dd>
      {hasRule && (
        <dd className="col-md-1">
          <ContainerTwoTone
            onClick={() => setShowNameHistoryModal(true)}
            twoToneColor="#17a2b8"
            style={{ marginLeft: '-30px', fontSize: '20px' }}
          />
        </dd>
      )}
      <dt className="col-sm-4">
        <span>OriginalPrice : </span>
      </dt>
      <dd className="col-sm-8">
        <span className="txt-gray">{productPriceSection?.originalPrice || '--'}</span>
      </dd>

      <dt className="col-sm-4">
        <span>Price : </span>
      </dt>
      <dd className="col-sm-8 txt-highlight">
        <span className="mr-3">{productPriceSection?.price || ''}</span>
        <span className="mr-3">{productPriceSection?.priceCN || ''}</span>
        <span className="mr-3 badge badge-danger">{productPriceSection?.off || ''}</span>
        <span className="mr-3 badge badge-danger">{productPriceSection?.extraOff || ''}</span>
        <span className="mr-3">
          <a href={`${salesHistoryLink()}`} target="_blank_" className="btn btn-link">
            Sales History
          </a>
        </span>
      </dd>
      {productPriceSection.type ? (
        <>
          {productPriceSection.type === 'product' && (
            <>
              <dt className="col-sm-4">
                <span>原始价格 : </span>
              </dt>
              <dd className="col-sm-8">
                <span className="txt-gray">{productPriceSection?.beforeMarkupPrice}</span>
              </dd>
            </>
          )}
          <dt className="col-sm-4">
            {productPriceSection.type === 'commission' ? (
              '改价幅度'
            ) : (
              <Tooltip placement="topLeft" title="预期改价幅度未计算折扣活动逻辑">
                改价幅度
                <Badge count={<QuestionOutlined />} style={tipStyle} />
              </Tooltip>
            )}
            :
          </dt>
          <dd className="col-sm-8">
            <Space size={15}>
              {productPriceSection.type === 'commission' ? (
                <Tooltip title="BGM商家或因折扣活动不满足加价要求，改为额外加手续费。">
                  <span className="txt-gray">
                    {productPriceSection.unit}
                    {productPriceSection?.diff}
                    <Badge count={<QuestionOutlined />} style={tipStyle} />
                  </span>
                </Tooltip>
              ) : (
                <span className="txt-gray">
                  {productPriceSection.unit}
                  {productPriceSection?.diff}
                </span>
              )}
              <Tag color="#108ee9">mark_up</Tag>
              {productPriceSection.type === 'commission' && (
                <Tag color="#108ee9">processing_fee</Tag>
              )}
              {!markUpId ? (
                <Tag color="#108ee9">系统加价</Tag>
              ) : (
                <Tooltip color="#fff" title={<Paragraph copyable>{markUpId}</Paragraph>}>
                  <Tag color="#108ee9">人工加价</Tag>
                </Tooltip>
              )}
            </Space>
          </dd>
          <dt className="col-sm-4">
            <Tooltip placement="topLeft" title="改价包含手续费">
              手续费
              <Badge count={<QuestionOutlined />} style={tipStyle} /> :
            </Tooltip>
          </dt>
          <dd className="col-sm-8">
            <span className="txt-gray">{getCommissionFee()}</span> <br />
          </dd>
        </>
      ) : null}
      <dt className="col-sm-4">
        <span>Inventory : </span>
      </dt>
      <dd className="col-sm-8">
        <span className="badge badge-dark">{inventery}</span> <br />
        <span className="badge badge-warning">{getPinToTime()}</span>
      </dd>

      <dt className="col-sm-4">
        <span>Operation : </span>
      </dt>
      <dd className="col-sm-2">
        <button className="btn btn-success btn-sm col-sm-12" onClick={refreshProductInfo}>
          Refresh
        </button>
      </dd>
      <dd className="col-sm-2">
        <button
          className="btn btn-danger btn-sm col-sm-12"
          data-toggle="modal"
          data-target="#pinPriceDesModal"
        >
          PIN Price
        </button>
      </dd>
      <dd className="col-sm-2">
        <button
          className="btn btn-danger btn-sm col-sm-12"
          data-toggle="modal"
          data-target="#pinDesModal"
        >
          {productPined ? 'UNPIN' : 'PIN'}
        </button>
      </dd>
      <dd className="col-sm-2">
        <button
          className="btn btn-success btn-sm col-sm-12"
          onClick={() => recrawlerProduct(product.id)}
        >
          重爬
        </button>
      </dd>
      <dt className="col-sm-4"></dt>
      <dd className="col-sm-2">
        <Link to={`/checkout/${product.id}`} target="_blank_">
          <button className="btn btn-info btn-sm col-sm-12">模拟结算</button>
        </Link>
      </dd>
      <dt className="col-sm-6"></dt>
      {getChoices() && (
        <>
          <dt className="col-sm-4">
            <span>Dismounting Reason : </span>
          </dt>
          <dd className="col-md-8">{getChoices()}</dd>
        </>
      )}
      <AntModal
        title="商品名修改记录"
        footer={null}
        visible={showNameHistoryModal}
        onCancel={() => setShowNameHistoryModal(false)}
      >
        <Table
          columns={[
            {
              title: '操作人',
              dataIndex: 'editor',
              key: 'editor',
              render: text => <a href={papyrusUserLookUpUrl + text}>{text}</a>,
            },
            {
              title: '操作时间',
              dataIndex: 'createdAt',
              key: 'createdAt',
              render: createdAt => <span>{new Date(createdAt).toLocaleString()}</span>,
            },
            {
              title: '修改前商品名',
              dataIndex: 'oldNameCN',
              key: 'oldNameCN',
            },
          ]}
          dataSource={modifyNameHistoryList}
        />
      </AntModal>
    </div>
  )
}

export default ProductDetailHeader
